import { render, staticRenderFns } from "./IconOpenBook.vue?vue&type=template&id=013ca954"
import script from "./IconOpenBook.vue?vue&type=script&lang=js"
export * from "./IconOpenBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports